<div class="container bg-white">
  <div class="row">
    <div class="col-60">
      <app-section-title2 color="dark" [title]="'label_news' | translate"></app-section-title2>
    </div>
  </div>
</div>

<div class="container bg-white">
  <ng-container *ngIf="items">
    <div class="position-relative">
      <div class="swiper-container swiper-container-news pb-4 pt-2 pb-lg-0" [swiper]="swiper_news_home"  >
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of items">
            <app-box-news-in-evidence [title]="item.title"
                                      [img]="item.image_preview ? item.image_preview_path : item.image_header_path"
                                      [slug]="item.title_slug"
                                      [date]="item.created_at"
                                      [description]="item.description_seo"></app-box-news-in-evidence>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-elsa"></div>
      </div>
      <div class="swiper-button-next" id="news-next" (click)="swiperDirective.prevSlide()">
      </div>
      <div class="swiper-button-prev" id="news-prev" (click)="swiperDirective.nextSlide()"></div>
    </div>
  </ng-container>

  <div class="d-flex justify-content-center mt-3 pb-5 mt-lg-2">
    <a [routerLink]="Paths.News | page | localize"
       class="btn text-white btn-gray btn-go-to-section text-uppercase mx-auto">
      {{'go_to_section' | translate}}
    </a>
  </div>
</div>
